"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReadmeValidator_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTitleAndDescription = exports.validateSections = exports.validateAndUpdate = exports.updateSectionContent = exports.save = exports.load = exports.createSection = exports.ReadmeValidator = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const structures_1 = require("@krauters/structures");
const fs_1 = require("fs");
const path_1 = require("path");
const package_json_1 = require("./package-json");
let ReadmeValidator = ReadmeValidator_1 = class ReadmeValidator {
    static createSection(readmeContent, section) {
        const { content, header, placeholder } = section;
        const sectionContent = content || placeholder || 'Placeholder content here';
        logger_1.log.info(`Creating section [${header}]...`);
        return `${readmeContent}\n## ${header}\n\n${sectionContent}\n`;
    }
    static load({ packageJsonPath, repoPath = '' }) {
        const packageJson = package_json_1.PackageJson.getPackageJson({ startDir: packageJsonPath });
        const path = (0, path_1.join)(repoPath, 'README.md');
        logger_1.log.info(`Loading README.md from [${path}]...`);
        if (!(0, fs_1.existsSync)(path)) {
            throw new Error(`README.md file not found in the repository at [${path}]`);
        }
        const content = (0, fs_1.readFileSync)(path, { encoding: structures_1.FileEncoding.UTF8 });
        logger_1.log.info(`Successfully loaded README.md`);
        return { content, packageJson, path };
    }
    static save(path, content) {
        logger_1.log.info(`Saving README.md to [${path}]...`);
        (0, fs_1.writeFileSync)(path, content, { encoding: structures_1.FileEncoding.UTF8 });
        logger_1.log.info(`Successfully saved README.md`);
    }
    static updateSectionContent(readmeContent, section) {
        const { content, header } = section;
        const updatedContent = `## ${header}\n\n${content}`;
        const sectionRegex = new RegExp(`## ${header}\\n[\\s\\S]*?(?=## |$)`, 'i');
        logger_1.log.info(`Updating section [${header}]...`);
        return readmeContent.replace(sectionRegex, updatedContent);
    }
    static validateAndUpdate(options = {}) {
        const { content, packageJson, path } = ReadmeValidator_1.load(options);
        const { autoCreateMissing, badgeSection = '', sections = [], updateContent, validateOnly } = options;
        let readmeContent = badgeSection + ReadmeValidator_1.validateTitleAndDescription(packageJson, content, validateOnly);
        sections.forEach((section) => {
            const { content, header, required } = section;
            const sectionExists = new RegExp(`## ${header}`, 'i').test(readmeContent);
            if (!sectionExists && required && !autoCreateMissing) {
                throw new Error(`Validation failed. Required section [${header}] is missing.`);
            }
            if (!sectionExists && autoCreateMissing) {
                readmeContent = ReadmeValidator_1.createSection(readmeContent, section);
            }
            if (sectionExists && updateContent && content) {
                readmeContent = ReadmeValidator_1.updateSectionContent(readmeContent, section);
            }
        });
        if (validateOnly) {
            ReadmeValidator_1.validateSections(readmeContent, sections);
            logger_1.log.info('README.md has been successfully validated.');
        }
        else {
            ReadmeValidator_1.save(path, readmeContent);
            logger_1.log.info('README.md has been successfully validated and updated.');
        }
        return {
            description: packageJson.description ?? '',
            sections,
            title: `# ${packageJson.name}`,
        };
    }
    static validateSections(readmeContent, sections) {
        sections.forEach(({ header, required }) => {
            if (required && !new RegExp(`## ${header}`, 'i').test(readmeContent)) {
                throw new Error(`Validation failed. Required section [${header}] is missing.`);
            }
        });
    }
    static validateTitleAndDescription(packageJson, readmeContent, validateOnly = false) {
        const expectedTitle = `# ${packageJson.name}`;
        const expectedDescription = packageJson.description ?? '';
        const titleExists = readmeContent.includes(expectedTitle);
        const descriptionExists = expectedDescription === '' || readmeContent.includes(expectedDescription);
        if (validateOnly) {
            if (!titleExists || !descriptionExists) {
                throw new Error(`Validation failed. README does not match expected title and description from package.json.\n` +
                    `Expected Title [${expectedTitle}]\nExpected Description [${expectedDescription}]`);
            }
            logger_1.log.info(`Main title and description validated successfully for [${packageJson.name}].`);
            return readmeContent;
        }
        if (!titleExists) {
            logger_1.log.info(`Adding main title and description for [${packageJson.name}]...`);
            return `${expectedTitle}\n\n${expectedDescription}\n\n${readmeContent}`;
        }
        logger_1.log.info(`Main title already exists for [${packageJson.name}]`);
        return readmeContent;
    }
};
exports.ReadmeValidator = ReadmeValidator;
exports.ReadmeValidator = ReadmeValidator = ReadmeValidator_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], ReadmeValidator);
exports.createSection = ReadmeValidator.createSection, exports.load = ReadmeValidator.load, exports.save = ReadmeValidator.save, exports.updateSectionContent = ReadmeValidator.updateSectionContent, exports.validateAndUpdate = ReadmeValidator.validateAndUpdate, exports.validateSections = ReadmeValidator.validateSections, exports.validateTitleAndDescription = ReadmeValidator.validateTitleAndDescription;
//# sourceMappingURL=readme-validator.js.map